window.SiteReady(($) => {

  console.log('Init Block: Testimonials - Featured');

  $('.block_testimonials_featured').each((_, block) => {
    const $block = $(block);

    const $splide = $block.hasClass('js-splide') ? $block : $block.find('.js-splide');
    const $current = $block.find('.js-testimonials_featured_current');
    const $total = $block.find('.js-testimonials_featured_total');

    if (!$splide.length || !$current.length) {
      return;
    }

    const bind = () => {
      const data = $splide.data('splide-data');

      if (!data || !data.Splide) {
        window.requestAnimationFrame(bind);
        return;
      }

      const splide = data.Splide;

      const update = () => {
        $current.text(splide.index + 1);

        if ($total.length) {
          $total.text(splide.length);
        }
      };

      splide.on('mounted move moved refresh updated', update);
      update();
    };

    bind();
  });

});
